export default "/_next/static/images/ab95377b899a69a8e5c730d0eb393079.png";